Object.assign(window.FazendaRP.Pages.financeiro, {

    renderMovimentacoes: async function (container) {
        container.innerHTML = '<div style="text-align:center; padding:30px;"><i class="fas fa-spinner fa-spin"></i> Carregando movimentações...</div>';

        // 1. Fetch Movimentações (Base)
        const { data: movimentos, error } = await window.FazendaRP.supabase
            .from('financeiro_movimentacoes')
            .select(`
                *,
                financeiro_lancamentos ( descricao, num_doc, anexos, parceiros(nome) ),
                financeiro_contas ( nome ),
                financeiro_conciliacoes ( 
                    id, 
                    data_conciliacao, 
                    tipo_match, 
                    score_confianca,
                    financeiro_extratos ( banco, periodo_inicio, nome_arquivo )
                )
            `)
            .order('data_operacao', { ascending: false });

        if (error) {
            console.error("Erro renderMovimentacoes:", error);
            container.innerHTML = `<div style="color:red; text-align:center; padding: 20px;">Erro ao carregar: ${error.message}</div>`;
            return;
        }

        // 2. Resolve Batch Partners (Multi-Step)
        // Find all movements that are batches and have IDs
        const batchMap = {}; // movId -> "Parceiro A, Parceiro B"
        const allBatchItemIds = [];

        movimentos.forEach(m => {
            if (m.detalhes && (m.detalhes.batch_ids || m.detalhes.items)) {
                const ids = m.detalhes.batch_ids || m.detalhes.items;
                if (Array.isArray(ids)) allBatchItemIds.push(...ids);
            }
        });

        if (allBatchItemIds.length > 0) {
            // Fetch Parceiros for ALL distinct items in batches
            const uniqueIds = [...new Set(allBatchItemIds)];

            // Chunking if too many (optional, but good practice). For now simple IN.
            const { data: batchItems, error: batchErr } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('id, parceiros(nome), num_doc')
                .in('id', uniqueIds);

            if (!batchErr && batchItems) {
                // Map: LancId -> {Nome, Doc}
                const itemRefMap = {};
                batchItems.forEach(i => {
                    itemRefMap[i.id] = {
                        nome: i.parceiros ? i.parceiros.nome : null,
                        doc: i.num_doc
                    };
                });

                // Re-iterate movements to build string
                movimentos.forEach(m => {
                    if (m.detalhes && (m.detalhes.batch_ids || m.detalhes.items)) {
                        const ids = m.detalhes.batch_ids || m.detalhes.items;
                        // Get names & docs
                        const names = ids.map(id => itemRefMap[id]?.nome).filter(n => n);
                        const docs = ids.map(id => itemRefMap[id]?.doc).filter(n => n);

                        m._calculatedPartners = [...new Set(names)].join(', ') || '-';
                        m._calculatedDocs = [...new Set(docs)].join(', ') || 'Vários';
                    }
                });
            }
        }

        // 3. Fallback for Single: Use joined relation
        movimentos.forEach(m => {
            if (!m._calculatedPartners) {
                if (m.financeiro_lancamentos && m.financeiro_lancamentos.parceiros) {
                    m._calculatedPartners = m.financeiro_lancamentos.parceiros.nome;
                } else {
                    m._calculatedPartners = '-';
                }
            }
        });


        // Render Base
        container.innerHTML = `
            <div class="data-table-container">
                <div class="action-bar">
                    <div class="filter-group">
                        <button id="btn-nova-transf" class="btn btn-primary" style="margin-right: 15px; background: #0ea5e9; border-color: #0ea5e9;">
                            <i class="fas fa-exchange-alt"></i> Nova Transferência
                        </button>
                        <button id="btn-print-mov" class="btn btn-secondary" style="margin-right: 15px;">
                            <i class="fas fa-print"></i> Imprimir
                        </button>
                        <button id="btn-export-mov" class="btn btn-secondary" style="margin-right: 15px; background-color: #059669; border-color: #059669; color: white;">
                             <i class="fas fa-file-excel"></i> Exportar
                        </button>

                        <div style="display:inline-flex; align-items:center; border:1px solid #ddd; border-radius:4px; padding:0 5px; margin-right:15px; background:white;">
                            <i class="fas fa-search" style="color:#999; margin-right:5px;"></i>
                            <input type="text" id="filtro-mov-search" placeholder="Parceiro, doc, valor..." style="border:none; outline:none; padding:8px; min-width:200px;">
                        </div>

                        <select id="filtro-conciliacao" style="padding:8px; border:1px solid #ddd; border-radius:4px; margin-right:15px; background:white; cursor:pointer;">
                            <option value="">📊 Todas</option>
                            <option value="conciliado">✅ Conciliadas</option>
                            <option value="pendente">⌛ Não Conciliadas</option>
                        </select>

                        <label style="margin-right: 5px; font-size: 0.9em; color: #666;">Período:</label>
                        <input type="date" id="filtro-mov-de" style="padding: 5px; border: 1px solid #ddd; border-radius: 4px;"> 
                        <span style="color: #999;">até</span>
                        <input type="date" id="filtro-mov-ate" style="padding: 5px; border: 1px solid #ddd; border-radius: 4px;">
                    </div>
                    <div style="flex: 1; text-align: right; font-size: 0.9em; color: #666;">
                        <span id="mov-count">${movimentos ? movimentos.length : 0}</span> registros encontrados
                    </div>
                </div>
                
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Docto.</th>
                            <th>Descrição (Origem)</th>
                            <th>Parceiro</th>
                            <th>Conta / Banco</th>
                            <th>Tipo</th>
                            <th>Valor</th>
                            <th>Conciliação</th>
                            <th>Detalhes</th>
                        </tr>
                    </thead>
                    <tbody id="lista-movimentacoes">
                        ${this.renderMovimentacoesRows(movimentos)}
                    </tbody>
                </table>
            </div>
        `;

        // Filtro Data Simple Logic (Front-end only for responsiveness, Backend better for huge data)
        const applyFilter = () => {
            const de = container.querySelector('#filtro-mov-de').value;
            const ate = container.querySelector('#filtro-mov-ate').value;
            const search = container.querySelector('#filtro-mov-search').value.toLowerCase();
            const statusConc = container.querySelector('#filtro-conciliacao').value;

            let filtered = movimentos || [];

            // Date Filter
            if (de) filtered = filtered.filter(m => m.data_operacao >= de);
            if (ate) filtered = filtered.filter(m => m.data_operacao <= ate);

            // Reconciliation Status Filter
            if (statusConc === 'conciliado') {
                filtered = filtered.filter(m => m.financeiro_conciliacoes && m.financeiro_conciliacoes.length > 0);
            } else if (statusConc === 'pendente') {
                filtered = filtered.filter(m => !m.financeiro_conciliacoes || m.financeiro_conciliacoes.length === 0);
            }

            // Search Filter
            if (search) {
                filtered = filtered.filter(m => {
                    const desc = (m.financeiro_lancamentos?.descricao || '').toLowerCase();
                    const parceiro = (m._calculatedPartners || '').toLowerCase();

                    // Doc: Combine single doc and batch docs
                    const docSingle = (m.financeiro_lancamentos?.num_doc || '').toLowerCase();
                    const docBatch = (m._calculatedDocs || '').toLowerCase();

                    // Value: Compare stringified number
                    const valorStr = (m.valor || 0).toString();
                    const valorFmt = m.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 }); // e.g. "1.000,00"

                    return desc.includes(search) ||
                        parceiro.includes(search) ||
                        docSingle.includes(search) ||
                        docBatch.includes(search) ||
                        valorStr.includes(search) ||
                        valorFmt.includes(search);
                });
            }

            container.querySelector('#lista-movimentacoes').innerHTML = this.renderMovimentacoesRows(filtered);
            container.querySelector('#mov-count').innerText = filtered.length;
            return filtered;
        };

        container.querySelector('#filtro-mov-de').addEventListener('change', applyFilter);
        container.querySelector('#filtro-mov-ate').addEventListener('change', applyFilter);
        container.querySelector('#filtro-mov-search').addEventListener('keyup', applyFilter);
        container.querySelector('#filtro-conciliacao').addEventListener('change', applyFilter);

        // Print Button
        container.querySelector('#btn-print-mov').addEventListener('click', () => {
            const list = applyFilter(); // Get currently filtered list
            const de = container.querySelector('#filtro-mov-de').value;
            const ate = container.querySelector('#filtro-mov-ate').value;
            let pText = "Todos os registros";
            if (de && ate) pText = `Período: ${de.split('-').reverse().join('/')} a ${ate.split('-').reverse().join('/')}`;
            else if (de) pText = `A partir de: ${de.split('-').reverse().join('/')}`;
            else if (ate) pText = `Até: ${ate.split('-').reverse().join('/')}`;

            this.imprimirRelatorioMovimentacoes(list, pText);
        });

        // Export Button
        container.querySelector('#btn-export-mov').addEventListener('click', () => {
            const list = applyFilter();
            this.exportarMovimentacoesCSV(list);
        });

        // Define default 'De' to first of current month?
        // Let's keep empty ('All time') for now.
        // Helper Nova Transferencia
        container.querySelector('#btn-nova-transf').addEventListener('click', () => {
            this.renderTransferenciaModal();
        });

        // Event Delegation (View & Delete)
        container.querySelector('#lista-movimentacoes').addEventListener('click', async (e) => {
            // 1. VIEW ORIGIN (Read Only Modal)
            const viewLink = e.target.closest('.view-origin-link');
            if (viewLink) {
                e.preventDefault();
                const lancId = viewLink.dataset.lancId;
                const movId = viewLink.dataset.movId;
                if (lancId) this.renderViewLancamentoModal(lancId, movId);
                return;
            }

            // 1. VIEW ANEXOS
            const btnAnexos = e.target.closest('.btn-view-anexos');
            if (btnAnexos) {
                e.preventDefault();
                const b64 = btnAnexos.dataset.anexosB64;
                const title = btnAnexos.dataset.title || 'Anexos';
                if (b64) {
                    try {
                        const json = decodeURIComponent(escape(atob(b64)));
                        const anexos = JSON.parse(json);
                        this.abrirVisualizadorAnexos(anexos, title);
                    } catch (err) {
                        console.error("Erro decode anexos", err);
                        alert("Erro ao abrir anexos.");
                    }
                }
                return;
            }

            // 2. FULL EDIT REMOVED (Policy: Revert & Redo)


            // 3. DELETE
            const btn = e.target.closest('.btn-delete-mov');
            if (btn) {
                this.deleteMovimentacao(btn.dataset.id, btn.dataset.lancId);
            }
        });

        // Event for Batch Link
        const listContainer = container.querySelector('#lista-movimentacoes');
        if (listContainer) {
            listContainer.addEventListener('click', (e) => {
                const batchLink = e.target.closest('.view-batch-link');
                if (batchLink) {
                    e.preventDefault();
                    const movId = batchLink.dataset.movId;
                    const mov = movimentos.find(m => m.id == movId);
                    if (mov) this.abrirModalDetalhesLote(mov);
                }
            });
        }
    },

    exportarMovimentacoesCSV: function (movimentos) {
        if (!movimentos || movimentos.length === 0) {
            alert("Não há dados para exportar.");
            return;
        }

        // Headers
        let csvContent = "Data;Documento;Descrição;Parceiro;Conta;Tipo;Valor;Observações\n";

        movimentos.forEach(m => {
            const dt = m.data_operacao.split('-').reverse().join('/');

            let docStr = '-';
            if (m.financeiro_lancamentos && m.financeiro_lancamentos.num_doc) docStr = m.financeiro_lancamentos.num_doc;
            else if (m._calculatedDocs) docStr = m._calculatedDocs;

            const desc = (m.financeiro_lancamentos ? m.financeiro_lancamentos.descricao : 'Transferência/Ajuste').replace(/;/g, ',');
            const parceiro = (m._calculatedPartners || '-').replace(/;/g, ',');
            const conta = (m.financeiro_contas ? m.financeiro_contas.nome : '-').replace(/;/g, ',');
            const tipo = m.tipo_movimentacao || m.tipo;

            // Format number for Excel (comma decimal)
            const valor = m.valor.toString().replace('.', ',');

            // Obs (optional details)
            let obs = '';
            if (m.detalhes) obs = JSON.stringify(m.detalhes).replace(/;/g, ' ').replace(/\n/g, ' ');

            // CSV Line
            csvContent += `${dt};${docStr};${desc};${parceiro};${conta};${tipo};${valor};${obs}\n`;
        });

        // BOM for Excel to recognize UTF-8
        const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `movimentacoes_financeiras_${new Date().toISOString().slice(0, 10)}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },

    imprimirRelatorioMovimentacoes: function (movimentos, periodoTexto) {
        if (!movimentos || movimentos.length === 0) {
            alert("Não há dados para imprimir com os filtros atuais.");
            return;
        }

        const logoDataUrl = window.FazendaRP_Logo || "";

        // Calculate Totals
        let totalCredito = 0;
        let totalDebito = 0;
        let saldoPeriodo = 0;

        const rows = movimentos.map(m => {
            const dt = m.data_operacao.split('-').reverse().join('/');
            const desc = m.financeiro_lancamentos ? m.financeiro_lancamentos.descricao : 'Transferência / Ajuste';
            const conta = m.financeiro_contas ? m.financeiro_contas.nome : '-';
            const tipo = m.tipo_movimentacao || m.tipo; // 'CREDITO' or 'DEBITO'
            const valor = m.valor;

            const parceiro = m._calculatedPartners || '-';

            // Doc logic for Print
            let docStr = '-';
            if (m.financeiro_lancamentos && m.financeiro_lancamentos.num_doc) {
                docStr = m.financeiro_lancamentos.num_doc;
            } else if (m._calculatedDocs) {
                docStr = m._calculatedDocs; // Batch docs
            }

            // Style for value
            const color = tipo === 'CREDITO' ? '#059669' : '#dc2626';
            const sign = tipo === 'CREDITO' ? '+' : '-';
            const valFmt = valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

            if (tipo === 'CREDITO') totalCredito += valor;
            else totalDebito += valor;

            return `
                <tr>
                    <td>${dt}</td>
                    <td>${docStr}</td>
                    <td><div style="font-weight:600;">${desc}</div></td>
                    <td>${parceiro}</td>
                    <td>${conta}</td>
                    <td><span style="font-size:10px; padding:2px 6px; border-radius:4px; background:${tipo === 'CREDITO' ? '#d1fae5' : '#fee2e2'}; color:${color}; font-weight:bold;">${tipo}</span></td>
                    <td style="color:${color}; text-align:right; font-weight:600;">${sign} ${valFmt}</td>
                </tr>
            `;
        }).join('');

        saldoPeriodo = totalCredito - totalDebito;
        const colorSaldo = saldoPeriodo >= 0 ? '#059669' : '#dc2626';

        const now = new Date();
        const win = window.open('', '_blank');
        win.document.write(`
            <html>
            <head>
                <base href="${window.location.origin}${window.location.pathname}">
                <title>Relatório de Movimentações Financeiras</title>
                <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" rel="stylesheet">
                <style>
                    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 13px; color: #333; padding: 20px; }
                    
                    /* Landscape Mode */
                    @page { size: landscape; margin: 10mm; }

                    /* Header Styles */
                    .header-container { display: flex; justify-content: space-between; align-items: center; border-bottom: 3px solid #047857; padding-bottom: 15px; margin-bottom: 20px; }
                    .header-left { display: flex; align-items: center; gap: 15px; }
                    .header-left img { height: 60px; width: auto; }
                    .header-text h1 { margin: 0; font-size: 24px; color: #065f46; letter-spacing: -0.5px; }
                    .header-text h2 { margin: 5px 0 0; font-size: 16px; color: #6b7280; font-weight: 500; }
                    .header-right { text-align: right; font-size: 12px; color: #6b7280; }
                    
                    /* Table Styles */
                    table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                    th { text-align: left; background-color: #065f46; color: white; padding: 8px 10px; font-size: 12px; text-transform: uppercase; font-weight: 600; }
                    td { padding: 8px 10px; font-size: 12px; vertical-align: top; border-bottom: 1px solid #e5e7eb; }
                    
                    /* Striped Rows */
                    tr:nth-child(even) { background-color: #f9fafb; }

                    /* Summary Boxes */
                    .summary-container { display: flex; justify-content: flex-end; gap: 20px; margin-top: 30px; }
                    .summary-box { 
                        background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px; padding: 15px; min-width: 200px;
                        display: flex; flex-direction: column; align-items: flex-end;
                    }
                    .sum-label { font-size: 11px; color: #6b7280; text-transform: uppercase; font-weight: 600; letter-spacing: 0.5px; margin-bottom: 5px; }
                    .sum-value { font-size: 18px; font-weight: bold; }

                    @media print {
                        body { padding: 0; -webkit-print-color-adjust: exact; }
                        .no-print { display: none; }
                        tr { page-break-inside: avoid; }
                        thead { display: table-header-group; } 
                        tfoot { display: table-footer-group; }
                        th { background-color: #065f46 !important; color: white !important; }
                    }
                </style>
            </head>
            <body>
                <div class="header-container">
                    <div class="header-left">
                        <img src="${logoDataUrl}" alt="Logo">
                        <div class="header-text">
                            <h1>${window.FazendaRP_NomeFazenda || 'Fazenda Rio do Peixe'}</h1>
                            <h2>Relatório de Movimentações Financeiras</h2>
                        </div>
                    </div>
                    <div class="header-right">
                        <strong>Emissão:</strong> ${now.toLocaleString('pt-BR')} <br>
                        ${periodoTexto}
                    </div>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th width="8%">Data</th>
                            <th width="10%">Docto</th>
                            <th width="25%">Descrição</th>
                            <th width="18%">Parceiro</th>
                            <th width="12%">Conta / Banco</th>
                            <th width="8%">Tipo</th>
                            <th width="12%" style="text-align:right;">Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${rows}
                    </tbody>
                </table>

                <div class="summary-container">
                    <div class="summary-box">
                        <div class="sum-label">Total Entradas</div>
                        <div class="sum-value" style="color: #059669;">${totalCredito.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                    </div>
                    <div class="summary-box">
                        <div class="sum-label">Total Saídas</div>
                        <div class="sum-value" style="color: #dc2626;">${totalDebito.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                    </div>
                    <div class="summary-box" style="border-color: ${saldoPeriodo >= 0 ? '#d1fae5' : '#fee2e2'}; background-color: ${saldoPeriodo >= 0 ? '#f0fdf4' : '#fef2f2'};">
                        <div class="sum-label">Saldo do Período</div>
                        <div class="sum-value" style="color: ${colorSaldo};">${saldoPeriodo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                    </div>
                </div>

                <script>
                    window.onload = function() { window.print(); window.close(); }
                </script>
            </body>
            </html>
        `);
        win.document.close();
    },

    abrirModalEditarPagamento: async function (lancId, movId) {
        // 1. Fetch Lancamento
        const { data: lanc, error } = await window.FazendaRP.supabase
            .from('financeiro_lancamentos')
            .select('*')
            .eq('id', lancId)
            .single();

        if (error || !lanc) {
            window.FazendaRP.Toast.show('error', 'Erro', 'Erro ao buscar dados do lançamento.');
            return;
        }

        // Defaults
        const currentData = lanc.data_pagamento || new Date().toISOString().split('T')[0];
        const currentConta = lanc.conta_id;
        // Assume current VALOR is the Final
        // We'll init "Base" as current, and Juros/Desc as 0, unless stored in details (unlikely in old data)
        const currentValor = lanc.valor;

        // 2. Load Accounts
        const { data: contas } = await window.FazendaRP.supabase
            .from('financeiro_contas')
            .select('id, nome')
            .order('nome');

        const contasOpts = contas.map(c => `<option value="${c.id}" ${c.id == currentConta ? 'selected' : ''}>${c.nome}</option>`).join('');

        // 3. Render Modal
        const modalId = 'modal-editar-pagamento';
        const modal = document.createElement('div');
        modal.id = modalId;
        modal.className = 'modal-overlay';
        modal.style.cssText = "position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);display:flex;justify-content:center;align-items:center;z-index:9999;";

        // HTML Structure matching Agenda
        modal.innerHTML = `
            <div style="background:white; padding:25px; border-radius:8px; width:450px; max-width:90%; position:relative;">
                <h3 style="margin-bottom:15px; color:#374151;">Editar Pagamento</h3>
                <p style="margin-bottom:5px; color:#666; font-size:0.95em;"><strong>${lanc.descricao}</strong></p>
                <div style="margin-bottom:20px; font-size:0.9em; color:#888;">
                     Valor Principal (Base): 
                     <input type="text" id="edit-pag-base" value="${currentValor}" style="width:100px; border:none; border-bottom:1px solid #ccc; font-weight:bold; color:#555; text-align:right;">
                </div>
                
                <div style="display:grid; grid-template-columns: 1fr 1fr; gap: 15px;">
                    <div class="form-group" style="margin-bottom:15px;">
                        <label style="font-size:0.85em; color:#555;">Data Pagamento</label>
                        <input type="date" id="edit-pag-data" class="form-control" value="${currentData}">
                    </div>
                    <div class="form-group" style="margin-bottom:15px;">
                        <label style="font-size:0.85em; color:#555;">Conta de Saída</label>
                        <select id="edit-pag-conta" class="form-control">
                            ${contasOpts}
                        </select>
                    </div>
                </div>

                <div style="display:grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 10px;">
                    <div class="form-group">
                        <label style="color: #dc2626; font-size:0.85em;">+ Multa/Juros</label>
                        <input type="text" id="edit-pag-juros" class="form-control" value="0,00" style="text-align:right;">
                    </div>
                    <div class="form-group">
                        <label style="color: #059669; font-size:0.85em;">- Desconto</label>
                        <input type="text" id="edit-pag-desconto" class="form-control" value="0,00" style="text-align:right;">
                    </div>
                </div>

                <div class="form-group" style="margin-bottom:20px;">
                    <label style="font-size:0.9em;"><strong>Valor Final Pago (R$)</strong></label>
                    <input type="text" id="edit-pag-valor" class="form-control" value="${currentValor}" style="font-weight:bold; font-size:1.2em; color: #111; text-align:right;">
                </div>

                <div style="display:flex; justify-content:flex-end; gap:10px;">
                    <button id="btn-cancel-edit-pag" class="btn btn-secondary">Cancelar</button>
                    <button id="btn-save-edit-pag" class="btn btn-primary" style="background:#f59e0b; border-color:#f59e0b;">Salvar Alterações</button>
                </div>
            </div>
        `;
        document.body.appendChild(modal);

        // --- MASK & CALC LOGIC (Copied from Agenda) ---
        const formatMoney = (val) => val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        const parseMoney = (valStr) => {
            if (!valStr) return 0;
            if (typeof valStr === 'number') return valStr;
            const clean = valStr.toString().replace(/\D/g, '');
            return parseFloat(clean) / 100;
        };

        const inpBase = modal.querySelector('#edit-pag-base');
        const inpJuros = modal.querySelector('#edit-pag-juros');
        const inpDesc = modal.querySelector('#edit-pag-desconto');
        const inpTotal = modal.querySelector('#edit-pag-valor');

        // Initial Formats
        inpBase.value = formatMoney(parseFloat(currentValor));
        inpJuros.value = "R$ 0,00"; // Explicit format
        inpDesc.value = "R$ 0,00";
        inpTotal.value = formatMoney(parseFloat(currentValor));

        const recalc = () => {
            const base = parseMoney(inpBase.value);
            const j = parseMoney(inpJuros.value);
            const d = parseMoney(inpDesc.value);
            const final = base + j - d;
            inpTotal.value = formatMoney(final > 0 ? final : 0);
        };

        const applyMask = (e) => {
            let value = e.target.value.replace(/\D/g, "");
            if (value === "") value = "0";
            const num = parseFloat(value) / 100;
            e.target.value = num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            recalc();
        };

        [inpBase, inpJuros, inpDesc].forEach(el => el.addEventListener('input', applyMask));

        // Final can be manual too? Agenda logic says "If source == inpTotal return".
        // But here let's allow manual override of Final just in case logic fails, but usually Recalc drives it.
        inpTotal.addEventListener('input', (e) => {
            // Just format, don't reverse calc
            let value = e.target.value.replace(/\D/g, "");
            if (value === "") value = "0";
            const num = parseFloat(value) / 100;
            e.target.value = num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        });

        // ----------------------------------------------

        // Close
        modal.querySelector('#btn-cancel-edit-pag').onclick = () => modal.remove();

        // Save
        modal.querySelector('#btn-save-edit-pag').onclick = async () => {
            const newData = modal.querySelector('#edit-pag-data').value;
            const newConta = modal.querySelector('#edit-pag-conta').value;
            const newValor = parseMoney(inpTotal.value);
            const juros = parseMoney(inpJuros.value);
            const desconto = parseMoney(inpDesc.value);

            if (!newData || !newConta || newValor <= 0) {
                alert("Dados inválidos (Valor zerado ou campos vazios).");
                return;
            }

            const btn = modal.querySelector('#btn-save-edit-pag');
            btn.disabled = true; btn.innerText = "Salvando...";

            try {
                // LOGICA SPLIT:
                // Se houver Juros ou Desconto, nós NÃO alteramos o valor do lançamento original (mantemos o Principal).
                // Em vez disso, criamos lançamentos "filhos" para Juros (2.4.1) e Descontos (3.1.1).

                // 1. Calcular o Principal (Valor Base original reconciliado)
                // Se o usuário editou o Total, mas manteve Juros/Desc 0, então o Principal mudou.
                // Se o usuário editou Juros/Desc, assumimos que o Principal é o inpBase.
                const principal = parseMoney(inpBase.value);

                // Validação básica
                if (Math.abs((principal + juros - desconto) - newValor) > 0.05) {
                    // Se a conta não bate (base + juros - desc != total), alertamos mas confiamos no Total e ajustamos a Base
                    // Ou forçamos recalc. Vamos confiar no Recalc que roda on input.
                }

                // A. Update Lancamento with detalhes
                const detalhes = lanc.detalhes || {};
                detalhes.juros = juros;
                detalhes.desconto = desconto;
                detalhes.valor_base = principal;
                detalhes.valor_total_pago = newValor;

                const { error: err1 } = await window.FazendaRP.supabase
                    .from('financeiro_lancamentos')
                    .update({
                        valor: newValor, // Total paid (base + juros - desconto)
                        data_pagamento: newData,
                        conta_id: newConta,
                        status: 'Pago',
                        detalhes: detalhes,
                        updated_at: new Date().toISOString()
                    })
                    .eq('id', lancId);

                if (err1) throw err1;

                // B. Update Movimentacao to match total paid
                const { error: err2 } = await window.FazendaRP.supabase
                    .from('financeiro_movimentacoes')
                    .update({
                        data_operacao: newData,
                        conta_id: newConta,
                        valor: newValor  // Total paid
                    })
                    .eq('id', movId);

                if (err2) throw err2;

                window.FazendaRP.Toast.show('success', 'Sucesso', 'Pagamento atualizado!');
                modal.remove();
                this.renderMovimentacoes(document.querySelector('#financeiro-content'));

            } catch (e) {
                console.error(e);
                alert("Erro ao salvar: " + e.message);
                btn.disabled = false; btn.innerText = "Salvar Alterações";
            }
        };
    },

    renderTransferenciaModal: function (prefill = null) {
        return new Promise(async (resolve) => {
            // 1. Load Data
            const { data: contas } = await window.FazendaRP.supabase.from('financeiro_contas').select('*').order('nome');
            const { data: parceiros } = await window.FazendaRP.supabase.from('parceiros').select('id, nome, cpf_cnpj').order('nome');
            const { data: plano } = await window.FazendaRP.supabase.from('financeiro_plano_contas')
                .select('codigo, nome, tipo')
                .in('tipo', ['ANALITICA', 'CONTA'])
                .order('codigo');

            // Defaults from prefill or standard
            const defData = (prefill && prefill.data) ? prefill.data.replace(/\s+/g, '') : new Date().toISOString().split('T')[0];
            const defValor = (prefill && prefill.valor) ? Math.abs(prefill.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '';
            const defObs = (prefill && prefill.obs) ? prefill.obs : '';
            const defTipo = (prefill && prefill.tipo_trf) ? prefill.tipo_trf : 'interna';

            // 2. Create Modal Elements
            const modalId = 'modal-transferencia';
            const existing = document.getElementById(modalId);
            if (existing) existing.remove();

            const modal = document.createElement('div');
            modal.id = modalId;
            modal.className = 'modal-overlay';
            modal.style.cssText = "position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); z-index:1000; display:flex; align-items:center; justify-content:center;";

            const contasOptions = (contas || []).map(c => `<option value="${c.id}">${c.nome}</option>`).join('');
            const parceirosOptions = (parceiros || []).map(p => `<option value="${p.id}">${p.nome}</option>`).join('');
            const planoOptions = (plano || []).map(p => `<option value="${p.codigo} - ${p.nome}">${p.codigo} - ${p.nome}</option>`).join('');

            modal.innerHTML = `
                <div class="modal-content" style="background:#fff; width:500px; max-width:95%; padding:25px; border-radius:12px; box-shadow:0 10px 30px rgba(0,0,0,0.2);">
                    <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;">
                        <h3 style="margin:0; font-size:1.3rem; color:#1f2937;">Nova Transferência</h3>
                        <button id="btn-close-trf" style="border:none; background:none; font-size:1.5rem; cursor:pointer; color:#6b7280;">&times;</button>
                    </div>

                    <!-- Toggle Type -->
                    <div style="display:flex; background:#f3f4f6; padding:4px; border-radius:8px; margin-bottom:20px;">
                        <button class="btn-toggle-trf ${defTipo === 'interna' ? 'active' : ''}" data-type="interna" style="flex:1; padding:8px; border:none; border-radius:6px; background:${defTipo === 'interna' ? '#fff' : 'transparent'}; color:${defTipo === 'interna' ? '#0f766e' : '#6b7280'}; font-weight:600; cursor:pointer; box-shadow:${defTipo === 'interna' ? '0 2px 4px rgba(0,0,0,0.05)' : 'none'};"> Interna (Entre Contas)</button>
                        <button class="btn-toggle-trf ${defTipo === 'externa' ? 'active' : ''}" data-type="externa" style="flex:1; padding:8px; border:none; border-radius:6px; background:${defTipo === 'externa' ? '#fff' : 'transparent'}; color:${defTipo === 'externa' ? '#0f766e' : '#6b7280'}; font-weight:600; cursor:pointer; box-shadow:${defTipo === 'externa' ? '0 2px 4px rgba(0,0,0,0.05)' : 'none'};"> Externa (Retirada/Pgto)</button>
                    </div>

                    <form id="form-transferencia">
                        <div style="display:grid; grid-template-columns: 1fr 1fr; gap:15px; margin-bottom:15px;">
                            <div class="form-group">
                                <label style="display:block; font-size:0.9rem; margin-bottom:5px;">Data</label>
                                <input type="date" id="trf-data" class="form-control" style="width:100%;" value="${defData}">
                            </div>
                            <div class="form-group">
                                <label style="display:block; font-size:0.9rem; margin-bottom:5px;">Valor (R$)</label>
                                <input type="text" id="trf-valor" class="form-control currency-mask" style="width:100%; color:#059669; font-weight:bold;" placeholder="R$ 0,00" value="${defValor}" required>
                            </div>
                        </div>

                        <div class="form-group" style="margin-bottom:15px;">
                            <label style="display:block; font-size:0.9rem; margin-bottom:5px;">Conta de Origem (Saiu de)</label>
                            <select id="trf-origem" class="form-control" style="width:100%;" required>
                                <option value="">Selecione...</option>
                                ${contasOptions}
                            </select>
                        </div>

                        <div class="form-group" style="margin-bottom:15px;">
                            <label id="lbl-destino" style="display:block; font-size:0.9rem; margin-bottom:5px;">Conta de Destino (Foi para)</label>
                            
                            <!-- Select Destino INTERNO -->
                            <select id="trf-destino-conta" class="form-control" style="width:100%;">
                                <option value="">Selecione a Conta...</option>
                                ${contasOptions}
                            </select>

                            <!-- Select Destino EXTERNO (Parceiro) -->
                            <select id="trf-destino-parceiro" class="form-control" style="width:100%; display:none;">
                                <option value="">Selecione o Recebedor...</option>
                                ${parceirosOptions}
                            </select>
                        </div>

                        <!-- Categoria (Apenas Externo) -->
                        <div id="trf-categoria-div" class="form-group" style="margin-bottom:15px; display:none;">
                            <label style="display:block; font-size:0.9rem; margin-bottom:5px;">Categoria / Plano de Contas *</label>
                            <input list="list-plano-contas-trf" id="trf-categoria" class="form-control" style="width:100%;" placeholder="Ex: Distribuição de Lucros">
                            <datalist id="list-plano-contas-trf">
                                ${planoOptions} 
                            </datalist>
                        </div>

                        <div class="form-group" style="margin-bottom:20px;">
                            <label style="display:block; font-size:0.9rem; margin-bottom:5px;">Observações</label>
                            <textarea id="trf-obs" class="form-control" style="width:100%;" rows="2" placeholder="Detalhes opcionais...">${defObs}</textarea>
                        </div>

                        <button type="submit" id="btn-salvar-trf" class="btn btn-primary" style="width:100%; padding:12px; font-size:1rem;">Confirmar Transferência</button>
                    </form>
                </div>
            `;

            document.body.appendChild(modal);

            // 3. Logic & Events
            const btnsToggle = modal.querySelectorAll('.btn-toggle-trf');
            const inputOrigem = modal.querySelector('#trf-origem');
            const inputDestinoConta = modal.querySelector('#trf-destino-conta');
            const inputDestinoParceiro = modal.querySelector('#trf-destino-parceiro');
            const divCategoria = modal.querySelector('#trf-categoria-div');
            const form = modal.querySelector('#form-transferencia');

            // Init Visibility based on defTipo
            if (defTipo === 'externa') {
                inputDestinoConta.style.display = 'none';
                inputDestinoParceiro.style.display = 'block';
                divCategoria.style.display = 'block';
                document.getElementById('lbl-destino').innerText = 'Favorecido / Recebedor';
                inputDestinoConta.required = false;
                inputDestinoParceiro.required = true;
                modal.querySelector('#trf-categoria').required = true;
            } else {
                // Default Int
                inputDestinoConta.style.display = 'block';
                inputDestinoParceiro.style.display = 'none';
                divCategoria.style.display = 'none';
                document.getElementById('lbl-destino').innerText = 'Conta de Destino (Foi para)';
                inputDestinoConta.required = true;
                inputDestinoParceiro.required = false;
                modal.querySelector('#trf-categoria').required = false;
            }

            btnsToggle.forEach(btn => {
                btn.addEventListener('click', () => {
                    btnsToggle.forEach(b => {
                        b.classList.remove('active');
                        b.style.background = 'transparent';
                        b.style.color = '#6b7280';
                        b.style.boxShadow = 'none';
                    });
                    btn.classList.add('active');
                    btn.style.background = '#fff';
                    btn.style.color = '#0f766e';
                    btn.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';

                    const type = btn.dataset.type;
                    if (type === 'interna') {
                        inputDestinoConta.style.display = 'block';
                        inputDestinoParceiro.style.display = 'none';
                        divCategoria.style.display = 'none';
                        document.getElementById('lbl-destino').innerText = 'Conta de Destino (Foi para)';
                        inputDestinoConta.required = true;
                        inputDestinoParceiro.required = false;
                        modal.querySelector('#trf-categoria').required = false;
                    } else {
                        inputDestinoConta.style.display = 'none';
                        inputDestinoParceiro.style.display = 'block';
                        divCategoria.style.display = 'block';
                        document.getElementById('lbl-destino').innerText = 'Favorecido / Recebedor';
                        inputDestinoConta.required = false;
                        inputDestinoParceiro.required = true;
                        modal.querySelector('#trf-categoria').required = true;
                    }
                });
            });

            // Close
            const closeModal = () => {
                modal.remove();
                resolve(null); // Resolve with null if closed without saving
            };
            modal.querySelector('#btn-close-trf').onclick = closeModal;
            modal.onclick = (e) => { if (e.target === modal) closeModal(); };

            // Mask (Custom R$ Logic)
            const inputValor = modal.querySelector('#trf-valor');
            inputValor.addEventListener('input', (e) => {
                let value = e.target.value.replace(/\D/g, "");
                const num = parseFloat(value) / 100;
                e.target.value = num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            });

            // Submit
            form.onsubmit = async (e) => {
                e.preventDefault();

                // ⚠️ CONFIRMATION DIALOG
                if (!confirm('Confirmar esta transferência/pagamento?')) {
                    return; // User cancelled
                }

                const btn = modal.querySelector('#btn-salvar-trf');
                btn.innerText = "Processando...";
                btn.disabled = true;

                try {
                    const tipo = modal.querySelector('.btn-toggle-trf.active').dataset.type;
                    const valorStr = modal.querySelector('#trf-valor').value;
                    const valor = parseFloat(valorStr.replace(/[^\d,]/g, '').replace(',', '.'));

                    if (!valor || valor <= 0) throw new Error("Valor inválido.");

                    const payload = {
                        tipo_trf: tipo,
                        data_operacao: modal.querySelector('#trf-data').value,
                        valor: valor,
                        origem_id: modal.querySelector('#trf-origem').value,
                        destino_id: tipo === 'interna' ? modal.querySelector('#trf-destino-conta').value : modal.querySelector('#trf-destino-parceiro').value,
                        categoria: tipo === 'externa' ? modal.querySelector('#trf-categoria').value : null,
                        obs: modal.querySelector('#trf-obs').value
                    };

                    if (payload.origem_id === payload.destino_id && tipo === 'interna') throw new Error("Origem e Destino devem ser diferentes.");

                    const createdMov = await this.salvarTransferencia(payload);

                    window.FazendaRP.Toast.show('success', 'Sucesso', 'Transferência realizada com sucesso!');

                    // Allow UI to update before removing?
                    modal.remove(); // Close manually to avoid double-resolve issues if using closeModal var

                    // If requested, do NOT refresh the main view (caller handles refresh)
                    if (prefill && prefill.preventRedirect) {
                        // Do nothing, just closed.
                    } else {
                        this.renderMovimentacoes(document.getElementById('financeiro-content')); // Refresh List
                    }

                    resolve(createdMov); // Resolve with Data

                } catch (err) {
                    console.error(err);
                    alert("Erro: " + err.message);
                    btn.innerText = "Confirmar Transferência";
                    btn.disabled = false;
                }
            };
        });
    },

    salvarTransferencia: async function (p) {
        // Logic for Internal vs External
        const { tipo_trf, data_operacao, valor, origem_id, destino_id, categoria, obs } = p;
        // FIX: Safely access user or fallback
        const user = (window.FazendaRP.App && window.FazendaRP.App.currentUser) ? window.FazendaRP.App.currentUser : { email: 'sistema' };

        if (tipo_trf === 'interna') {
            // DUPLO LANÇAMENTO (Débito na Origem, Crédito no Destino)
            // Batch ID para ligar os dois
            const batchId = 'trf_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            const comum = {
                data_operacao,
                valor,
                created_by: user.email,
                detalhes: { items: [], obs: obs + " (Ref: " + batchId + ")", is_transfer: true, batch_id: batchId }
            };

            const movSaida = {
                ...comum,
                conta_id: origem_id,
                tipo: 'DEBITO',
                historico: 'TRF Enviada'
            };

            const movEntrada = {
                ...comum,
                conta_id: destino_id,
                tipo: 'CREDITO',
                historico: 'TRF Recebida'
            };

            const { data: movs, error } = await window.FazendaRP.supabase
                .from('financeiro_movimentacoes')
                .insert([movSaida, movEntrada])
                .select(); // Select inserted

            if (error) throw error;
            // Return Debit (Origem) movement for matching
            return movs.find(m => m.tipo === 'DEBITO');

        } else {
            // EXTERNA (Apenas Débito na Origem, mas com Parceiro e Categoria)

            // Generate Sequential TRF Number (only count new 5-digit format)
            const { data: lastTrf } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('num_doc')
                .like('num_doc', 'TRF-%')
                .order('created_at', { ascending: false })
                .limit(100); // Get multiple to filter

            let nextNum = 1;
            if (lastTrf && lastTrf.length > 0) {
                // Only match new format: TRF-##### (exactly 5 digits)
                const validTrfs = lastTrf
                    .map(row => row.num_doc.match(/^TRF-(\d{5})$/))
                    .filter(match => match !== null)
                    .map(match => parseInt(match[1]));

                if (validTrfs.length > 0) {
                    nextNum = Math.max(...validTrfs) + 1;
                }
            }
            const numDoc = 'TRF-' + nextNum.toString().padStart(5, '0');

            // ... Passo 1: Criar Lançamento ...
            const { data: lanc, error: errLanc } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .insert([{
                    tipo: 'Despesa',
                    data_emissao: data_operacao,
                    data_vencimento: data_operacao,
                    data_pagamento: data_operacao,
                    descricao: 'TRF Externa: ' + (obs || 'Retirada'),
                    valor: valor,
                    status: 'Pago',
                    parceiro_id: destino_id,
                    categoria: categoria,
                    conta_id: origem_id,
                    num_doc: numDoc,
                    forma_pagamento: 'Transferência Bancária',
                    detalhes: { obs: obs, is_transfer: true, origin: 'quick_transfer', tipo_doc: 'Outros', num_doc: numDoc }
                }])
                .select()
                .single();

            if (errLanc) throw errLanc;

            const { data: movs, error: errMov } = await window.FazendaRP.supabase
                .from('financeiro_movimentacoes')
                .insert([{
                    lancamento_id: lanc.id,
                    conta_id: origem_id,
                    data_operacao,
                    tipo: 'DEBITO',
                    valor,
                    historico: 'Pagamento/Retirada: ' + (categoria || '')
                }])
                .select(); // Select inserted

            if (errMov) throw errMov;
            return movs[0];
        }
    },

    renderMovimentacoesRows: function (lista) {
        if (!lista || lista.length === 0) return '<tr><td colspan="7" style="text-align:center; padding:20px; color: #888;">Nenhuma movimentação no período.</td></tr>';

        return lista.map(m => {
            const dataFmt = m.data_operacao ? m.data_operacao.split('-').reverse().join('/') : '-';

            // Logic for Description: Link vs Batch
            let desc = '';
            let isBatch = false;

            if (m.lancamento_id) {
                if (m.financeiro_lancamentos) {
                    desc = m.financeiro_lancamentos.descricao;
                } else {
                    desc = '(Lançamento Excluído)';
                }
            } else {
                // Batch or Manual
                isBatch = true;
                desc = m.historico || 'Movimentação Diversa';
            }

            // num_doc Display
            let numDoc = '-';
            if (m.financeiro_lancamentos && m.financeiro_lancamentos.num_doc) {
                numDoc = m.financeiro_lancamentos.num_doc;
            } else if (m._calculatedDocs) {
                // If Batch, show aggregated docs
                numDoc = m._calculatedDocs;
            }

            const contaNome = m.financeiro_contas ? m.financeiro_contas.nome : '(Conta Excluída)';
            const isCredito = m.tipo === 'CREDITO';
            const color = isCredito ? '#059669' : '#dc2626';
            const signal = isCredito ? '+' : '-';

            // Partner Display
            const partnerNames = m._calculatedPartners || '-';

            // ATTACHMENT CHECK
            let hasAttachments = false;
            let anexoUrl = '';
            if (m.financeiro_lancamentos && m.financeiro_lancamentos.anexos) {
                try {
                    const anexos = typeof m.financeiro_lancamentos.anexos === 'string'
                        ? JSON.parse(m.financeiro_lancamentos.anexos)
                        : m.financeiro_lancamentos.anexos;
                    if (Array.isArray(anexos) && anexos.length > 0) {
                        hasAttachments = true;
                        anexoUrl = anexos[0].url; // Link to first
                    }
                } catch (e) { }
            }

            // ACTION COLUMN HTML
            let actionHtml = '';

            // Check Attachments
            let anexos = [];
            if (m.financeiro_lancamentos && m.financeiro_lancamentos.anexos) {
                anexos = m.financeiro_lancamentos.anexos;
                if (typeof anexos === 'string') {
                    try { anexos = JSON.parse(anexos); } catch (e) { anexos = []; }
                }
            }

            // CONCILIAÇÃO BADGE
            const concInfo = m.financeiro_conciliacoes?.[0];
            const concBadge = concInfo
                ? `<span class="badge badge-success" style="cursor:pointer; font-size:0.75rem;" onclick="window.FazendaRP.Pages.financeiro.abrirModalConciliacao(${m.id}, 'mov')" title="Conciliado em ${new Date(concInfo.data_conciliacao).toLocaleString('pt-BR')}"><i class="fas fa-check-circle"></i> Conciliado</span>`
                : `<span class="badge badge-secondary" style="font-size:0.75rem;"><i class="fas fa-clock"></i> Pendente</span>`;

            return `
            <tr class="tr-hover">
                <td>${dataFmt}</td>
                <td><span style="font-family:monospace; font-weight:600; color:#444;">${numDoc}</span></td>
                <td>
                    <div style="font-weight: 500; color: #333;">${desc}</div>
                    ${!isBatch ? `<a href="#" class="view-origin-link" data-lanc-id="${m.lancamento_id}" data-mov-id="${m.id}" style="font-size: 0.8em; color: var(--color-primary);">Ver Lançamento Origem</a>` : ''}
                    ${isBatch && m.detalhes && (m.detalhes.batch_ids || m.detalhes.items) ? `<a href="#" class="view-batch-link" data-mov-id="${m.id}" style="font-size: 0.8em; color: var(--color-primary);">Ver Detalhes do Lote</a>` : ''}
                </td>
                <td>
                    <div style="font-size: 0.9em; color: #555; max-width: 200px; white-space: normal;">${partnerNames}</div>
                </td>
                <td>${contaNome}</td>
                <td><span class="badge ${isCredito ? 'badge-success' : 'badge-danger'}">${m.tipo}</span></td>
                <td style="color: ${color}; font-weight: 600;">${signal} ${window.FazendaRP.Utils.formatMoney(parseFloat(m.valor))}</td>
                <td>${concBadge}</td>
                <td>
                    <div style="display:flex; align-items:center;">
                        ${actionHtml}
                        <button class="btn-delete-mov" data-id="${m.id}" data-lanc-id="${m.lancamento_id || ''}" title="Excluir" style="border:none; background:none; color:red; cursor:pointer;">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </td>
            </tr>
            `;
        }).join('');
    },

    renderViewLancamentoModal: async function (lancId, highlightMovId) {
        // 1. Fetch Full Data
        const { data: lanc, error } = await window.FazendaRP.supabase
            .from('financeiro_lancamentos')
            .select(`*, parceiros(nome), financeiro_contas(nome)`)
            .eq('id', lancId)
            .single();

        if (error || !lanc) {
            console.error("Erro carregando detalhes:", error);
            window.FazendaRP.Toast.show('error', 'Erro', 'Não foi possível carregar os detalhes (Ver Console).');
            return;
        }

        const modal = document.createElement('div');
        modal.className = 'modal-overlay';
        modal.style.cssText = "position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);display:flex;justify-content:center;align-items:center;z-index:9999;";

        // 2. Parse Attachments
        let anexosHtml = '<i style="color:#999;">Sem anexos.</i>';
        if (lanc.anexos && Array.isArray(lanc.anexos) && lanc.anexos.length > 0) {
            anexosHtml = lanc.anexos.map(a => {
                const ext = (a.nome || '').split('.').pop().toLowerCase();
                let icon = 'fa-file';
                if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) icon = 'fa-file-image';
                else if (['pdf'].includes(ext)) icon = 'fa-file-pdf';
                else if (['xml'].includes(ext)) icon = 'fa-file-code';

                return `<div style="display:inline-flex; align-items:center; gap:5px; margin-right:15px; margin-bottom:5px;">
                    <i class="fas ${icon}" style="color:#3b82f6;"></i>
                    <a href="${a.url}" target="_blank" style="color:#3b82f6; text-decoration:none; font-size:0.9rem;">${a.nome}</a>
                </div>`;
            }).join('');
        }

        // 2a. Read Juros/Descontos from detalhes
        let childrenHtml = '';
        const detJuros = parseFloat(lanc.detalhes?.juros || 0);
        const detDesc = parseFloat(lanc.detalhes?.desconto || 0);

        if (lanc.detalhes && (detJuros > 0.001 || detDesc > 0.001)) {
            const juros = detJuros;
            const desconto = detDesc;

            childrenHtml = `
            <div style="margin-top:15px; padding:12px; background:#fef3c7; border-left:4px solid #f59e0b; border-radius:6px;">
                <div style="font-size:0.85rem; color:#92400e; font-weight:600; margin-bottom:8px;">AJUSTES DE PAGAMENTO</div>
                ${juros > 0 ? `
                <div style="display:flex; justify-content:space-between; padding:5px 0; border-bottom:1px dashed #fde68a;">
                    <span style="color:#78350f; font-size:0.9rem;">+ Juros</span>
                    <span style="color:#dc2626; font-weight:600; font-size:0.9rem;">R$ ${parseFloat(juros).toFixed(2)}</span>
                </div>
                ` : ''}
                ${desconto > 0 ? `
                <div style="display:flex; justify-content:space-between; padding:5px 0; border-bottom:1px dashed #fde68a;">
                    <span style="color:#78350f; font-size:0.9rem;">- Desconto</span>
                    <span style="color:#059669; font-weight:600; font-size:0.9rem;">R$ ${parseFloat(desconto).toFixed(2)}</span>
                </div>
                ` : ''}
            </div>
            `;
        }
        // 3. Items Table
        let itensHtml = '';
        const rawItems = (lanc.detalhes && lanc.detalhes.itens) ? lanc.detalhes.itens : [];

        if (rawItems && rawItems.length > 0) {
            itensHtml = `
            <table style="width:100%; font-size:0.9rem; border-collapse: collapse; margin-top:10px;">
                <tr style="background:#f9fafb; color:#666;">
                    <th style="padding:5px; text-align:left;">Item</th>
                    <th style="padding:5px; text-align:right;">Total</th>
                </tr>
                ${rawItems.map(i => {
                const nome = i.nome || i.descricao || i.item || '(Item)';
                const qtd = i.qtd || 1;
                const unidade = i.unidade || 'un';
                const total = i.total || 0;
                return `
                    <tr style="border-bottom:1px solid #eee;">
                        <td style="padding:5px;">${nome} <span style="color:#888; font-size:0.8em;">(${qtd} ${unidade})</span></td>
                        <td style="padding:5px; text-align:right;">R$ ${parseFloat(total).toFixed(2)}</td>
                    </tr>
                `;
            }).join('')}
            </table>`;
        }

        modal.innerHTML = `
            <div style="background:white; padding:25px; border-radius:8px; width:500px; max-width:90%; position:relative;">
                <h3 style="margin-bottom:15px; color:#1f2937;">Detalhes do Lançamento</h3>
                
                <div style="margin-bottom:10px; font-weight:bold; font-size:1.1rem; color:#374151;">
                    ${lanc.descricao}
                </div>
                
                <div style="display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-bottom:15px; background:#f9fafb; padding:10px; border-radius:6px;">
                    <div>
                        <small style="color:#666;">Valor Original</small><br>
                        <strong>R$ ${parseFloat(lanc.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong>
                    </div>
                    <div>
                        <small style="color:#666;">Data Pagamento</small><br>
                        <strong>${lanc.data_pagamento ? lanc.data_pagamento.split('-').reverse().join('/') : '-'}</strong>
                    </div>
                    <div>
                        <small style="color:#666;">Parceiro</small><br>
                        <span>${lanc.parceiros ? lanc.parceiros.nome : '-'}</span>
                    </div>
                    <div>
                        <small style="color:#666;">Conta</small><br>
                        <span>${lanc.financeiro_contas ? lanc.financeiro_contas.nome : '-'}</span>
                    </div>
                </div>

                ${anexosHtml !== '<i style="color:#999;">Sem anexos.</i>' ? `<div style="margin-bottom:15px;"><strong>Anexos:</strong><br>${anexosHtml}</div>` : ''}
                
                ${childrenHtml}

                ${itensHtml}

                <div style="text-align:right; margin-top:20px;">
                    <button class="btn-close-modal" style="background:#e5e7eb; border:none; padding:8px 15px; border-radius:4px; cursor:pointer;">Fechar</button>
                </div>
            </div>
        `;
        document.body.appendChild(modal);

        modal.querySelector('.btn-close-modal').onclick = () => modal.remove();
    },

    abrirModalDetalhesLote: async function (mov) {
        if (!mov || !mov.detalhes) return;

        const ids = mov.detalhes.batch_ids || mov.detalhes.items || [];
        if (ids.length === 0) return alert("Nenhum item vinculado a este lote.");

        // Fetch Items
        const { data: items, error } = await window.FazendaRP.supabase
            .from('financeiro_lancamentos')
            .select('id, descricao, valor, detalhes, parceiros(nome)')
            .in('id', ids);

        if (error) {
            console.error(error);
            return alert("Erro ao carregar itens do lote.");
        }

        const modal = document.createElement('div');
        modal.className = 'modal-overlay';
        modal.style.cssText = "position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);display:flex;justify-content:center;align-items:center;z-index:9999;";

        let totalOrig = 0;
        let totalPago = 0;

        const rows = items.map(item => {
            const det = item.detalhes || {};

            // CORRECT LOGIC for Batch Payments on Installments:
            // item.valor = Net Amount Paid (after discount) for THIS INSTALLMENT
            // det.desconto = Discount applied to THIS INSTALLMENT
            // Original = Net + Discount

            const vLiquido = parseFloat(item.valor);
            const desc = parseFloat(det.desconto || 0);
            const vBruto = vLiquido + desc; // Calculate original from net + discount

            totalOrig += vBruto;
            totalPago += vLiquido;

            return `
                <tr style="border-bottom:1px solid #eee;">
                    <td style="padding:8px;">
                        <div style="font-weight:600; color:#374151;">${item.descricao}</div>
                        <div style="font-size:0.8em; color:#666;">${item.parceiros?.nome || ''}</div>
                    </td>
                    <td style="padding:8px; text-align:right; color:#6b7280;">${vBruto.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                    <td style="padding:8px; text-align:right; color:#059669;">- ${desc.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                    <td style="padding:8px; text-align:right; font-weight:bold; color:#111;">${vLiquido.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                </tr>
            `;
        }).join('');

        modal.innerHTML = `
            <div style="background:white; padding:25px; border-radius:8px; width:600px; max-width:95%; max-height:80vh; display:flex; flex-direction:column;">
                <h3 style="margin-bottom:15px; color:#065f46; border-bottom:1px solid #eee; padding-bottom:10px;">
                    <i class="fas fa-layer-group"></i> Detalhes do Pagamento em Lote
                </h3>

                <div style="overflow-y:auto; flex:1;">
                    <table style="width:100%; border-collapse:collapse; font-size:0.9rem;">
                        <thead style="background:#f9fafb; color:#6b7280; font-size:0.85rem;">
                            <tr>
                                <th style="padding:8px; text-align:left;">Descrição</th>
                                <th style="padding:8px; text-align:right;">Valor Original</th>
                                <th style="padding:8px; text-align:right;">Desconto</th>
                                <th style="padding:8px; text-align:right;">Pago</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${rows}
                        </tbody>
                        <tfoot style="background:#f0fdf4; border-top:2px solid #bbf7d0;">
                            <tr>
                                <td style="padding:10px; font-weight:bold;">TOTAL</td>
                                <td style="padding:10px; text-align:right; font-weight:bold;">${totalOrig.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                                <td style="padding:10px; text-align:right;"></td>
                                <td style="padding:10px; text-align:right; font-weight:bold; color:#064e3b;">${totalPago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div style="text-align:right; margin-top:20px;">
                    <button class="btn-close-batch" style="background:#e5e7eb; border:none; padding:8px 15px; border-radius:4px; cursor:pointer;">Fechar</button>
                </div>
            </div>
        `;
        document.body.appendChild(modal);
        modal.querySelector('.btn-close-batch').onclick = () => modal.remove();
    },


    deleteMovimentacao: async function (id, lancamentoId) {
        let msg = "Tem certeza que deseja excluir esta movimentação?";

        // 1. Fetch Move Details and Lanc Details if linked
        const { data: mov } = await window.FazendaRP.supabase
            .from('financeiro_movimentacoes')
            .select('detalhes')
            .eq('id', id)
            .single();

        const batchIds = (mov && mov.detalhes && mov.detalhes.batch_ids) ? mov.detalhes.batch_ids : null;

        if (batchIds) {
            msg += `\nEsta é uma movimentação em LOTE. Isso estornará AUTOMATICAMENTE seus ${batchIds.length} lançamentos originais para 'Pendente'.`;
        } else if (lancamentoId) {
            msg += `\nIsso recalculará o saldo do lançamento original (estorno).`;
        } else {
            msg = "⚠️ ATENÇÃO: Movimentação sem vínculo rastreável.\nExcluí-la pode NÃO reverter os lançamentos originais automaticamente.\n\nDeseja continuar?";
        }

        if (!confirm(msg)) return;

        try {
            // Priority 1: Handle Batch Revert (Legacy/Full Payments OR Installments)
            if (batchIds && batchIds.length > 0) {
                // For each lancamento in batch, check if it has parcelas and find which one was paid
                for (const lancId of batchIds) {
                    const { data: lanc } = await window.FazendaRP.supabase
                        .from('financeiro_lancamentos')
                        .select('detalhes')
                        .eq('id', lancId)
                        .single();

                    if (lanc && lanc.detalhes && lanc.detalhes.pagamentos) {
                        // Find payment by mov id
                        const pagIdx = lanc.detalhes.pagamentos.findIndex(p => String(p.movimentacao_id) === String(id));

                        if (pagIdx >= 0) {
                            const pagToRemove = lanc.detalhes.pagamentos[pagIdx];
                            const detalhes = lanc.detalhes;

                            // Revert Status of Parcela if linked
                            if (pagToRemove.parcela_idx !== undefined && pagToRemove.parcela_idx !== null) {
                                if (detalhes.parcelas && detalhes.parcelas[pagToRemove.parcela_idx]) {
                                    detalhes.parcelas[pagToRemove.parcela_idx].status = 'Pendente';
                                    detalhes.parcelas[pagToRemove.parcela_idx].data_pagamento = null;
                                    detalhes.parcelas[pagToRemove.parcela_idx].valor_pago_real = 0;
                                }
                            }

                            // Remove Payment
                            detalhes.pagamentos.splice(pagIdx, 1);

                            // Recalc Totals & Discount (Source of Truth)
                            detalhes.valor_pago = detalhes.pagamentos.reduce((acc, p) => {
                                let principal = p.principal;
                                if (principal === undefined) principal = p.valor - (p.juros || 0) + (p.desconto || 0);
                                return acc + principal;
                            }, 0);

                            detalhes.desconto = detalhes.pagamentos.reduce((acc, p) => acc + (p.desconto || 0), 0);

                            // Recalc Status
                            const valorOriginal = parseFloat(lanc.valor);
                            const saldo = valorOriginal - detalhes.valor_pago;
                            let novoStatus = 'Parcialmente Pago';
                            if (saldo >= valorOriginal - 0.01) novoStatus = 'Pendente';
                            if (saldo <= 0.01) novoStatus = 'Pago';

                            await window.FazendaRP.supabase
                                .from('financeiro_lancamentos')
                                .update({ detalhes: detalhes, status: novoStatus })
                                .eq('id', lancId);
                        } else {
                            // Fallback if payment not found in array? Just set pending?
                            // Better to be safe and set pending if no payments left
                            if (lanc.detalhes.pagamentos.length === 0) {
                                await window.FazendaRP.supabase
                                    .from('financeiro_lancamentos')
                                    .update({ status: 'Pendente', data_pagamento: null, conta_id: null })
                                    .eq('id', lancId);
                            }
                        }
                    } else {
                        // Legacy / No details
                        await window.FazendaRP.supabase
                            .from('financeiro_lancamentos')
                            .update({ status: 'Pendente', data_pagamento: null, conta_id: null })
                            .eq('id', lancId);
                    }

                }

                window.FazendaRP.Toast.show('info', 'Lote Estornado', `${batchIds.length} lançamentos processados.`);
            }
            // Priority 2: Handle Single Linked Launch (Partial or Full)
            else if (lancamentoId && lancamentoId !== 'null') {

                // Fetch Launch Details
                const { data: lanc, error: errLanc } = await window.FazendaRP.supabase
                    .from('financeiro_lancamentos')
                    .select('*')
                    .eq('id', lancamentoId)
                    .single();

                if (errLanc) { console.warn("Lançamento não encontrado para estorno:", errLanc); }
                else if (lanc) {
                    // Logic to remove payment from array
                    const detalhes = lanc.detalhes || {};
                    const pagamentos = detalhes.pagamentos || [];

                    // Find payment by mov id (Ensure type match)
                    const pagIdx = pagamentos.findIndex(p => String(p.movimentacao_id) === String(id));

                    if (pagIdx >= 0) {
                        const pagToRemove = pagamentos[pagIdx];

                        // Revert Installment Status if linked
                        if (pagToRemove.parcela_idx !== undefined && pagToRemove.parcela_idx !== null) {
                            if (detalhes.parcelas && detalhes.parcelas[pagToRemove.parcela_idx]) {
                                detalhes.parcelas[pagToRemove.parcela_idx].status = 'Pendente';
                                detalhes.parcelas[pagToRemove.parcela_idx].data_pagamento = null;
                                detalhes.parcelas[pagToRemove.parcela_idx].valor_pago_real = 0;
                            }
                        }

                        // Remove specific payment
                        pagamentos.splice(pagIdx, 1);
                        detalhes.pagamentos = pagamentos; // Update ref

                        // FIX: Recalculate Totals from Scatter (Source of Truth)
                        // This fixes any previous drift/corruption (e.g. stuck 50.00)
                        detalhes.valor_pago = pagamentos.reduce((acc, p) => {
                            let principal = p.principal;
                            if (principal === undefined) principal = p.valor - (p.juros || 0) + (p.desconto || 0);
                            return acc + principal;
                        }, 0);

                        detalhes.desconto = pagamentos.reduce((acc, p) => acc + (p.desconto || 0), 0);

                        // Recalc Status
                        const valorOriginal = parseFloat(lanc.valor);
                        const saldo = valorOriginal - detalhes.valor_pago;
                        let novoStatus = 'Parcialmente Pago';
                        if (saldo >= valorOriginal - 0.01) novoStatus = 'Pendente';
                        if (saldo <= 0.01) novoStatus = 'Pago';

                        // Update Launch
                        await window.FazendaRP.supabase
                            .from('financeiro_lancamentos')
                            .update({ detalhes: detalhes, status: novoStatus })
                            .eq('id', lancamentoId);

                    } else {
                        // Fallback: If no payment array found or not linked, assume Full Revert (Legacy behavior)
                        // Only if status was Paid
                        if (lanc.status === 'Pago' || lanc.status === 'Parcialmente Pago') {
                            await window.FazendaRP.supabase
                                .from('financeiro_lancamentos')
                                .update({ status: 'Pendente', data_pagamento: null, conta_id: null })
                                .eq('id', lancamentoId);
                        }
                    }
                }
            }

            // Finally: Delete Movimentacao
            const { error: errDel } = await window.FazendaRP.supabase.from('financeiro_movimentacoes').delete().eq('id', id);
            if (errDel) throw errDel;

            window.FazendaRP.Toast.show('success', 'Movimentação Excluída', 'Estorno realizado com sucesso.');
            this.renderMovimentacoes(document.getElementById('financeiro-content')); // Refresh
        } catch (error) {
            console.error(error);
            alert("Erro ao excluir movimentação: " + error.message);
        }
    },

    abrirModalConciliacao: async function (movId, tipo) {
        const idField = tipo === 'mov' ? 'movimentacao_id' : 'lancamento_id';
        const { data, error } = await window.FazendaRP.supabase
            .from('financeiro_conciliacoes')
            .select('*, financeiro_extratos(id, banco, mes_competencia, nome_arquivo)')
            .eq(idField, movId)
            .order('data_conciliacao', { ascending: false })
            .limit(1)
            .single();

        if (error || !data) { alert('Nenhuma informação de conciliação encontrada.'); return; }

        const extrato = data.financeiro_extratos;
        const dataConciliacao = new Date(data.data_conciliacao).toLocaleString('pt-BR');
        const tipoMatch = { 'AUTO': '🤖 Automática', 'MANUAL': '👤 Manual', 'SUGESTAO_ACEITA': '💡 Sugestão', 'LEGADO': '📦 Legado' }[data.tipo_match] || data.tipo_match;

        const modal = document.createElement('div');
        modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);display:flex;justify-content:center;align-items:center;z-index:9999;';
        modal.innerHTML = `
            <div style="background:white; padding:25px; border-radius:12px; width:500px; max-width:95%;">
                <h3 style="margin:0 0 20px 0; color:#10b981; border-bottom:2px solid #10b981; padding-bottom:10px;"><i class="fas fa-check-circle"></i> Conciliação Bancária</h3>
                <div style="background:#f0fdf4; padding:15px; border-radius:8px; margin-bottom:15px;">
                    <div style="margin-bottom:8px;"><strong>Data:</strong> ${dataConciliacao}</div>
                    <div style="margin-bottom:8px;"><strong>Tipo:</strong> ${tipoMatch}</div>
                    ${data.score_confianca ? `<div><strong>Score:</strong> ${data.score_confianca}%</div>` : ''}
                    ${data.conciliado_por ? `<div style="margin-top:8px;"><small>Por: ${data.conciliado_por}</small></div>` : ''}
                </div>
                ${extrato ? `
                    <div style="background:#eff6ff; padding:15px; border-radius:8px; margin-bottom:15px;">
                        <div style="font-weight:700; margin-bottom:10px; color:#1e40af;">📄 Extrato Vinculado</div>
                        <div><strong>Banco:</strong> ${extrato.banco || '-'}</div>
                        <div><strong>Período:</strong> ${extrato.mes_competencia || '-'}</div>
                        <div style="font-size:0.85rem; color:#666; margin-top:6px;">${extrato.nome_arquivo || ''}</div>
                        <button onclick="window.FazendaRP.Pages.conciliacao.loadFromHistory('${extrato.id}'); window.FazendaRP.navigateTo('financeiro', 'conciliacao'); this.closest('div[style*=fixed]').remove();" 
                            style="margin-top:10px; width:100%; background:#3b82f6; color:white; border:none; padding:10px; border-radius:6px; cursor:pointer; font-weight:600;">
                            <i class="fas fa-external-link-alt"></i> Ver Extrato Bancário
                        </button>
                    </div>
                ` : '<div style="text-align:center; padding:20px; color:#9ca3af;">Sem extrato vinculado</div>'}
                ${data.observacoes ? `
                    <div style="background:#fef3c7; padding:12px; border-radius:8px; margin-bottom:15px; border-left:4px solid #f59e0b;">
                        <div style="font-size:0.75rem; color:#92400e; font-weight:600; margin-bottom:4px;">OBSERVAÇÕES</div>
                        <div style="color:#78350f;">${data.observacoes}</div>
                    </div>
                ` : ''}
                <button onclick="this.closest('div[style*=fixed]').remove()" style="width:100%; background:#e5e7eb; border:none; padding:10px; border-radius:6px; cursor:pointer; font-weight:600;">Fechar</button>
            </div>
        `;
        document.body.appendChild(modal);
    }

});
